import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";

import { ResultItemComponent } from "./components/search-results/result-item/result-item.component";
import { SearchResultsComponent } from "./components/search-results/search-results.component";
import { NewsSearchComponent } from "./news-search.component";

@NgModule({
    declarations: [
        NewsSearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [NewsSearchComponent],
    imports: [
        CommonComponentsModule
    ]
})
export class NewsSearchModule {
}
